import { action } from 'easy-peasy';
import { IActionSetCrisisCallTeamMembers } from '../types';
import { createTeamMemberWithCalculatedStatus } from './helpers';

const setCrisisCallTeamMembers: IActionSetCrisisCallTeamMembers = action((state, payload) => {
  state.crisisCallTeamMembers = payload.map(createTeamMemberWithCalculatedStatus);
});

export default setCrisisCallTeamMembers;
